import Link from '@/lib/siteLink';

export default function DevmobFooter() {
  return (
    <footer className="bg-[#0B1120] text-white pt-16 pb-8" data-testid="devmob-footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <img src="/devmob-logo.png" alt="DevMob" className="h-7 w-auto brightness-0 invert mb-4" />
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">Technology partner for businesses building websites, mobile apps, enterprise software, and gaming products.</p>
            <a href="mailto:project@devmob.co" className="text-[#4A9FF5] hover:underline text-sm mt-3 inline-block">project@devmob.co</a>
          </div>
          <div>
            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">Services</h4>
            <ul className="space-y-2.5">
              <li><Link to="/devmob/services" className="text-sm text-gray-400 hover:text-white transition-colors">Web Development</Link></li>
              <li><Link to="/devmob/services" className="text-sm text-gray-400 hover:text-white transition-colors">Mobile Apps</Link></li>
              <li><Link to="/devmob/services" className="text-sm text-gray-400 hover:text-white transition-colors">Enterprise Software</Link></li>
              <li><Link to="/devmob/services" className="text-sm text-gray-400 hover:text-white transition-colors">Gaming</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/devmob/about" className="text-sm text-gray-400 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/devmob/portfolio" className="text-sm text-gray-400 hover:text-white transition-colors">Portfolio</Link></li>
              <li><Link to="/devmob/careers" className="text-sm text-gray-400 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/devmob/contact" className="text-sm text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              <li><a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors" data-testid="devmob-footer-sitemap">Sitemap</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4">Get in Touch</h4>
            <p className="text-sm text-gray-400">project@devmob.co</p>
            <p className="text-sm text-gray-500 mt-3">Bangalore, India</p>
            <Link to="/devmob/contact" className="inline-block mt-4 bg-[#2B7DE9] text-white px-5 py-2 rounded-lg text-sm font-semibold hover:bg-[#1A6AD4] transition-colors">Start a Project</Link>
          </div>
        </div>
        <div className="border-t border-white/5 pt-6 text-[11px] text-gray-600">&copy; 2026 DevMob. All rights reserved.</div>
      </div>
    </footer>
  );
}
